import { Color } from '../../utils/colors';

import { LabelCommonProps } from './types';

export const TEXT_COLOR_BY_BACKGROUND_COLOR: Record<
  LabelCommonProps['backgroundColor'],
  Extract<Color, 'ink100' | 'white100' | 'pink120'>
> = {
  error100: 'white100',
  cream100: 'ink100',
  success100: 'white100',
  ink100: 'white100',
  ink20: 'ink100',
  blue100: 'ink100',
  pink20: 'pink120',
  pink40: 'ink100',
  pink100: 'ink100',
  pink120: 'white100',
  primary100: 'ink100',
  white100: 'ink100',
  yellow100: 'ink100',
  info10: 'ink100',
};
